export default "__VITE_ASSET__GhhicMhl__"